import { authFetch } from 'api';
import * as types from '../constants/actionTypes';

const request = () => ({
	type: types.SEARCH_REQUEST,
});

const success = results => ({
	type: types.SEARCH_SUCCESS,
	payload: {
		results,
	},
});

const failure = message => ({
	type: types.SEARCH_FAILURE,
	payload: {
		message,
	},
});

export function navigateToSearch(history) {
	return (dispatch, getState) => {
		const state = getState();

		const { query = '' } = state.form.topSearchForm.values;

		const params = `?query=${query}`;
		return history.push('/search' + params);
	};
}

export function sendSearch() {
	return (dispatch, getState, { schema }) => {
		dispatch(request());

		const state = getState();
		const { token } = state.auth;

		const { query } = state.form.searchForm.values;
		const params = `?query=${query}`;

		authFetch('search' + params, {}, token, dispatch)
			.then(res => res.json())
			.then(res => {
				if (res.error) {
					dispatch(failure(res.error));
				}

				dispatch(success(res));
			})
			.catch(error => dispatch(failure(error.message || error)));
	};
}



// WEBPACK FOOTER //
// ./src/actions/search.js